import { render, staticRenderFns } from "./msg-list.vue?vue&type=template&id=46288346&scoped=true&"
import script from "./msg-list.vue?vue&type=script&lang=js&"
export * from "./msg-list.vue?vue&type=script&lang=js&"
import style0 from "./msg-list.vue?vue&type=style&index=0&id=46288346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46288346",
  null
  
)

export default component.exports